<template>
  <div class="d-flex align-items-stretch w-100" style="min-height: 64px">
    <!-- Назад и заголовок -->
    <div class="d-flex align-items-center flex-shrink-0">
      <btn-back @back="$emit('back')" />

      <span v-if="text" class="ms-3 title-font fs-2 fw-bold">
        {{ text }}
      </span>
    </div>

    <!-- Категории -->
    <div class="d-flex align-items-stretch flex-grow-1 mx-4" style="min-width: 0">
      <slot name="center" />
    </div>

    <!-- Поиск -->
    <div v-if="$slots.right" class="d-flex align-items-center flex-shrink-0">
      <slot name="right" />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue, prop } from "vue-class-component";
import { theme } from "@/store/modules/theme";

import BtnBack from "../../buttons/btn-back.vue";

class Props {
  text = prop<string>({ required: false, default: "" });
}

@Options({ components: { btnBack: BtnBack } })
class StandartHelpPanel extends Vue.with(Props) {
  theme = theme();
}
export default StandartHelpPanel;
</script>

<style lang="scss" scoped></style>
